// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInISOWeekYears/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInISOWeekYears = convertToFP(fn, 2);
export default differenceInISOWeekYears;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInISOWeekYears/index.js
// module id = 837
// module chunks = 0